import React from 'react';
import { ConversationPaneWrapper } from '../InboxPage/InboxPage.styled';
import {
    TransientConversation,
    JobInfoCard,
    useSetSelectedConversationId,
    JobApplicationEvent,
    getEncryptedConversationId,
    makeTransientConversationId,
    type SendMessageUiState,
} from '@indeed/messaging-react';
import { TransientConversationProps } from '../InboxPage/InboxPage';
import { useHistory, useLocation } from 'react-router-dom';
import ConversationContainer from '../ConversationContainer/ConversationContainer';
import ConversationBeginEventContainer from '../ConversationBeginEventContainer';

export const ConversationPane = ({
    conversationId,
    transientConversation,
    isSinglePane,
    navigationHandlers,
}: {
    conversationId: string | undefined;
    isSinglePane: boolean;
    transientConversation: TransientConversationProps | undefined;
    navigationHandlers?: {
        onBackClick?: () => void;
        onNavigateToJobDetails?: () => void;
    };
}) => {
    const history = useHistory();
    const location = useLocation();
    const setSelectedConversationId = useSetSelectedConversationId();

    return (
        <ConversationPaneWrapper>
            {conversationId && (
                <ConversationContainer
                    conversationId={conversationId}
                    renderBeforeListComponents={[
                        <ConversationBeginEventContainer
                            key={`conversation-begin-event-${conversationId}`}
                            conversationId={conversationId}
                        />,
                        <JobInfoCard
                            key={`job-info-card-${conversationId}`}
                            conversationId={conversationId}
                        />,
                    ]}
                    navigationHandlers={isSinglePane ? navigationHandlers : undefined}
                />
            )}
            {transientConversation && !conversationId && (
                <TransientConversation
                    conversationId={makeTransientConversationId(transientConversation.jobKey)}
                    transientConversation={transientConversation}
                    renderBeforeListComponents={[
                        <JobApplicationEvent
                            key={`job-application-event-new-conversation`}
                            jobKey={transientConversation.jobKey}
                            partnerId={transientConversation.jobBoardPartnerId}
                        />,
                        <JobInfoCard
                            key={`job-info-card-new-conversation`}
                            jobKey={transientConversation.jobKey}
                        />,
                    ]}
                    messageRequestsHandlers={{
                        onSendMessageSuccess: ({
                            conversationId: newConversationId,
                            uiState,
                        }: {
                            eventId: string;
                            conversationId?: string;
                            fileCount?: number;
                            uiState?: SendMessageUiState;
                        }) => {
                            if (newConversationId && uiState?.isFromActiveSelection !== false) {
                                setSelectedConversationId(newConversationId);
                                // Remove token from search params
                                const searchParams = new URLSearchParams(location.search);
                                searchParams.delete('token');
                                const cleanSearch = searchParams.toString();

                                history.replace({
                                    pathname: `/conversations/${getEncryptedConversationId(
                                        newConversationId
                                    )}`,
                                    search: cleanSearch ? `?${cleanSearch}` : '',
                                });
                            }
                        },
                    }}
                />
            )}
        </ConversationPaneWrapper>
    );
};
